import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { ACCOUNTS_QUERY_KEY } from "./useAccounts";

type UpdateAccountBody = components["schemas"]["UpdateAccountBody"];
type AccountResponse = components["schemas"]["AccountResponse"];

export type UpdateAccountVariables = {
  accountId: string;
  body: UpdateAccountBody;
};

export function useUpdateAccount() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AccountResponse, Error, UpdateAccountVariables>({
    mutationFn: async ({ accountId, body }) => {
      const { data, error } = await client.PATCH("/api/accounts/{account_id}", {
        params: { path: { account_id: accountId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to update account ${accountId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
